import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { API } from "../App";

// Founder-only: mints a 5-minute signed link for a verification/eligibility document and opens it.
export const SecureDocButton = ({ kind, verificationId, userId, label, testId }) => {
  const [busy, setBusy] = useState(false);

  const open = async () => {
    const win = window.open("about:blank", "_blank");
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/founder/secure-docs/link`, { kind, verification_id: verificationId, user_id: userId });
      const url = `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
      if (win) { win.opener = null; win.location.href = url; } else { window.location.href = url; }
    } catch (e) {
      if (win) win.close();
      toast.error(e.response?.data?.detail || "Couldn't open document");
    } finally { setBusy(false); }
  };

  return (
    <button
      type="button"
      onClick={open}
      disabled={busy}
      title={`${label} — opens a 5-minute secure link (founder only, logged)`}
      className="p-2 hover:bg-[#F0ECF7] rounded-lg transition-colors inline-flex items-center gap-1 text-xs text-[#64748B] disabled:opacity-60"
      data-testid={testId}
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}{label}
    </button>
  );
};

export const DocStatusNote = ({ deleted, testId }) => (
  <span className="text-xs text-[#475569] italic" data-testid={testId}>
    {deleted ? "Files permanently deleted after review" : "Documents visible to founder only"}
  </span>
);

export default SecureDocButton;
